import {
  type ReportConfigRemoveInput,
  type ReportConfigRemoveSuccess,
  toResponseError,
} from '@terros/common'
import { type RemoveHookResponse, mutationRemove } from '../../hooks'
import { useTantalimMutation } from '../../mutation'
import { useReportConfigCache } from './cache'

export function useRemoveReportConfig(): RemoveHookResponse<ReportConfigRemoveInput> {
  const cache = useReportConfigCache()

  const mutation = useTantalimMutation<ReportConfigRemoveInput, ReportConfigRemoveSuccess>({
    url: '/report/config/remove',
  })

  async function remove(input: ReportConfigRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      cache.removeItem(input.reportConfigId)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
